<template>
    <nav class="navBar" v-if="show">
        <img :src="require('@/assets/gomXchange.png')" alt="gomXchange logo" class="navLogo">
        <div class="navLinkGroup">
            <router-link  v-for="obj in navOptions" :key="obj.name" :to="obj.link" class="navLink">{{obj.name}}</router-link>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'header-nav',
    props: [
        "enableNoBorder"
    ],
    data: () => ({
        navOptions: [
            {
                name: "Live Map",
                link: {
                    name: "Home"
                }
            },
            {
                name: "About",
                link: {
                    name: "About"
                }
            },
            {
                name: "Trending",
                link: {
                    name: "Trending"
                }
            },
            {
                name: "Analytics",
                link: {
                    name: "Analytics"
                }
            },
            {
                name: "API",
                link: {
                    name: "API"
                }
            }
        ],
        show: true
    }),
    methods: {
        checkNoBorder: function() {
            var globv = this;
            if (globv.enableNoBorder && ![null, undefined].includes(globv.$route.query.noborder)) {
                globv.show = !globv.$route.query.noborder;
            }
            else {
                globv.show = true;
            }
        }
    },
    mounted: function() {
        var globv = this;
        globv.checkNoBorder();
    },
    watch: {
        '$route.query.noborder': function() {
            var globv = this;
            globv.checkNoBorder();
        }
    }
}
</script>

<style lang="scss">
.navBar {
    background-color: #eaeaea;
    background-color: var(--navBackgroundColor);
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.navLogo {
    height: 3rem;
}

.navLinkGroup {
    display: flex;
}

.navLink {
    color: var(--primaryColor);
    padding: 10px;
    display: flex;
    align-items: center;
    text-decoration: none;
    font-weight: bold;

    &:hover {
        background-color: var(--primaryColor);
        color: white;
        filter: saturate(0.5);
    }
}

@media (max-width: 820px) {
    .navBar {
        flex-direction: column;
        align-items: center;
        padding-bottom: 10px;
    }
}
</style>